The relative place of the phase in the overall process.
